import { moment } from "../date";
import type { Tables } from "../types";
import { getEmploymentDailyTargetSeconds } from "./get-employment-daily-target-seconds";
import { getEmploymentForDate } from "./get-employment-for-date";
import { getIsScheduledDay } from "./get-is-scheduled-day";

/**
 * The working time a person's contracts ask of the week a date falls in, Monday to Sunday: each
 * scheduled day's share of the weekly hours, the way the insights card weighs a day — a day off
 * the contract's workdays or on a public holiday of its region asks nothing. Every day is judged
 * against the contract in force on it, so a contract that changes mid-week splits the week.
 *
 * @param employments - The person's contracts, newest first, as the server reads them.
 * @param date - Any day of the week, as `YYYY-MM-DD`.
 * @returns The week's target in seconds, or `null` when no contract covers any day of it.
 */
export function getWeekTargetSeconds(
	employments: Array<Tables<"employments">>,
	date: string,
): number | null {
	const day = moment(date).startOf("isoWeek");
	let targetSeconds = 0;
	let hasEmployment = false;

	for (let index = 0; index < 7; index++) {
		const employment = getEmploymentForDate(employments, day.db());
		if (employment) {
			hasEmployment = true;
			if (getIsScheduledDay(employment, day)) {
				targetSeconds += getEmploymentDailyTargetSeconds(employment);
			}
		}
		day.add(1, "day");
	}

	return hasEmployment ? targetSeconds : null;
}
